module.exports = __webpack_public_path__ + "img/tidal.2cd38ddf.png";